<template>
  <div class="mx-auto my-2">
    <div v-if="!showTable">
      <v-alert
          border="left"
          color="blue"
          colored-border
          dense
          elevation="2"
          icon="mdi-information-variant"
      >
        Please use this
        <strong>
          <a :href="item" download>Generic Entry Sample</a>
        </strong>
        excel file before upload!
        <strong>
          Or
          <a
              style="text-decoration: underline; font-style: italic"
              @click="goBack()"
          >Go Back</a
          >
        </strong>
      </v-alert>
    </div>

    <div v-if="!showTable && !showUpload" class="mb-6">
      <upload-excel-component
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
      />
    </div>

    <div v-if="showUpload" class="selected mb-6">
      Selected file: {{ fileName }}
      <v-btn v-if="!loading" color="primary" @click="uploadGraduates"
      >
        <v-icon dark>mdi-cloud-upload</v-icon>
        Upload
      </v-btn>
      <v-container v-if="loading" style="height: 100px">
        <v-row align-content="center" class="fill-height" justify="center">
          <v-col class="subtitle-1 text-center" cols="12"
          >Uploading your file
          </v-col
          >
          <v-col cols="6">
            <v-progress-linear
                color="primary accent-4"
                height="6"
                indeterminate
                rounded
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-card v-if="showTable" class="mx-2" flat>
      <v-card-title>
        <v-flex class="p-2" xs2>
          <v-text-field
              v-model="name"
              hide-details
              label="Name"
              single-line
          ></v-text-field>
        </v-flex>
        <v-flex class="p-2" xs1>
          <v-text-field
              v-model="idValue"
              hide-details
              label="Id No"
              single-line
          ></v-text-field>
        </v-flex>
        <v-flex class="p-2" xs2>
          <v-autocomplete
              v-model="programValue"
              :clearable="clearable"
              :items="EDUCATIONAL_PROGRAMS"
              :loading="lookupLoading"
              item-text="name"
              item-value="id"
              label="Educational Program"
              return-object
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-2" xs2>
          <v-autocomplete
              v-model="disciplineValue"
              :clearable="clearable"
              :items="DISCIPLINES"
              :loading="lookupLoading"
              item-text="name"
              item-value="id"
              label="Discipline"
              return-object
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-2" xs2>
          <v-autocomplete
              v-model="levelOfStudyValue"
              :clearable="clearable"
              :items="LEVEL_OF_STUDIES"
              :loading="lookupLoading"
              item-text="name"
              item-value="id"
              label="Level Of Study"
              return-object
          ></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
            v-if="canCreateGEntry"
            class="success white--text mr-2"
            depressed
            @click="addGenericEntry"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add</span>
        </v-btn>
        <v-btn
            v-if="canCreateGEntry"
            class="primary white--text"
            depressed
            @click="newImport"
        >
          <v-icon left>mdi-import</v-icon>
          <span>New Import</span>
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="tableData.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="tableData.count"
          class="elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.fullName`]="{ item }">
          {{ item.fullName ? item.fullName : "-" }}
        </template>
        <template v-slot:[`item.sex`]="{ item }">
          {{ item.sex ? item.sex : "-" }}
        </template>
        <template v-slot:[`item.idNo`]="{ item }">
          {{ item.idNo ? item.idNo : "-" }}
        </template>
        <template v-slot:[`item.educationProgram`]="{ item }">
          {{ item.educationProgram ? item.educationProgram : "-" }}
        </template>
        <template v-slot:[`item.entryYear`]="{ item }">
          {{ item.entryYear ? item.entryYear : "-" }}
        </template>
        <template v-slot:[`item.yearOfGraduation`]="{ item }">
          {{ item.yearOfGraduation ? item.yearOfGraduation : "-" }}
        </template>
        <template v-slot:[`item.higherLearningInstitution`]="{ item }">
          {{
            item.higherLearningInstitution
                ? item.higherLearningInstitution
                : "-"
          }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="viewImportedGraduates(item)"
                  v-on="on"
              >mdi-eye
              </v-icon
              >
            </template>
            <span>View generic entry pre-service detail</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-if="canEditGEntry" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editImportedGraduate(item)"
                  v-on="on"
              >mdi-circle-edit-outline
              </v-icon
              >
            </template>
            <span>Edit Generic Entries</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <GraduatesDetail
              v-if="detailDialog"
              :graduates="graduates"
              @close="detailDialog = false"
          ></GraduatesDetail>
        </v-card>
      </v-dialog>
    </template>

    <template>
      <v-dialog v-model="addDialog" persistent width="50%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdAddGenericEntry
              v-if="addDialog"
              :graduates="graduates"
              @close="addDialog = false"
              @registerOrUpdateGenericEntries="registerOrUpdateGenericEntries"
          ></HrdAddGenericEntry>
        </v-card>
      </v-dialog>
    </template>
    <importErrorModal
        :dialogState="importErrorsDialog"
        :importErrors="importErrors"
        @dialogEvent="() =>importErrorsDialog = false"
    ></importErrorModal>
  </div>
</template>

<script>
import sampleExcelFile from "@/assets/file/Generic_Entry_Sample.xlsx";
import UploadExcelComponent from "../UploadExcel.vue";
import {GraduateService} from "../graduates.service";
import GraduatesDetail from "./graduates-detail.vue";
// import UpdateImportedGraduate from "./update-imported-graduate.vue";
import HrdAddGenericEntry from "./add-generic-entry.vue";
import {getDisciplines, getEducationalPrograms, getLevelOfStudies, getUser} from "@/utils/helper";
import importErrorModal from "../importErrorModal.vue";
import {EducLevelEnum} from "@/utils/enums";

export default {
  components: {
    UploadExcelComponent,
    GraduatesDetail,
    // UpdateImportedGraduate,
    HrdAddGenericEntry,
    importErrorModal,
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      fileName: "",
      importErrorsDialog: false,
      importErrors: [],
      loading: false,
      showTable: true,
      showUpload: false,
      showUploadExcel: false,
      headers: [
        {text: "Full Name", value: "fullName"},
        {text: "Sex", value: "sex"},
        // { text: "Date Of Birth", value: "dateOfBirth" },
        {text: "ID-No", value: "idNo"},
        // { text: "Discipline/Field Of Study", value: "profession" },
        {text: "Education Program", value: "educationProgram.name"},
        // { text: "Level Of Study", value: "levelOfStudy" },
        // { text: "Entry Program", value: "entryProgram" },
        {text: "Entry Year", value: "entryYear"},
        // { text: "Proposed Year Of Graduation", value: "proposedYearOfGraduation" },
        // { text: "Year Of Graduation", value: "yearOfGraduation" },
        // { text: "Year Of Education", value: "yearOfEducation" },
        {text: "Year Of Graduation", value: "graduationYear"},
        // { text: "University Owner", value: "universityOwner" },
        {
          text: "Higher Learning Institution",
          value: "university.name",
        },
        // { text: "Region", value: "region" },
        // { text: "Town", value: "town" },
        // { text: "GPA", value: "GPA" },
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      graduates: [],
      detailDialog: false,
      dialog: false,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      addDialog: false,

      lookupLoading: false,
      LEVEL_OF_STUDIES: [],
      DISCIPLINES: [],
      EDUCATIONAL_PROGRAMS: [],
      EDUC_LEVEL: [],

      programValue: null,
      allDisciplines: [],
      disciplineValue: null,
      levelOfStudyValue: null,
      idValue: null,
      name: null,
      clearable: true,

      item: sampleExcelFile
    };
  },
  async beforeMount() {
    this.fetchImportedGraduates();
    await this.loadLookups();
  },
  watch: {
    options: {
      handler() {
        this.fetchImportedGraduates();
      },
      deep: true,
    },
    name: function (val) {
      this.name = val;
      this.fetchImportedGraduates();
    },
    idValue: function (val) {
      this.idValue = val;
      this.fetchImportedGraduates();
    },
    programValue: function (val) {
      this.programValue = val == '' ? null : val;
      this.fetchOnFilters();
      this.fetchImportedGraduates();
    },
    disciplineValue: function (val) {
      this.disciplineValue = val == '' ? null : val;
      this.fetchImportedGraduates();
    },
    levelOfStudyValue: function (val) {
      this.levelOfStudyValue = val == '' ? null : val;
      this.fetchImportedGraduates();
    },

  },
  computed: {
    canCreateGEntry() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Pre-service" &&
              permission.canCreate
      );
    },
    canEditGEntry() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Pre-service" &&
              permission.canUpdate
      );
    },
  },
  methods: {
    async fetchOnFilters() {
      this.DISCIPLINES = this.allDisciplines.filter(x => x.educationProgramId == this.programValue.id);
    },
    async loadLookups() {
      this.lookupLoading = true;
      this.EDUC_LEVEL = await EducLevelEnum;
      this.LEVEL_OF_STUDIES = await getLevelOfStudies();
      this.LEVEL_OF_STUDIES = this.LEVEL_OF_STUDIES.rows.filter(x => x?.level_type == 'Generic Entry');
      this.allDisciplines = await getDisciplines();
      this.allDisciplines = this.allDisciplines.rows;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms()
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows
      this.lookupLoading = false;
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$toast.warning("Please do not upload files larger than 1m in size.");
      return false;
    },
    newImport() {
      this.showTable = false;
    },
    goBack() {
      this.showTable = true;
      this.showUpload = false;
      this.tableData = [];
      this.fetchImportedGraduates();
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.addDialog = false;
      this.fetchImportedGraduates();
    },
    handleSuccess({results, fileName}) {
      let errors = [];
      const requiredFields = [
        "firstName",
        "fatherName",
        "grandFatherName",
        "sex",
        "dateOfBirth",
        "idNo",
        "educationProgramId",
        "disciplineId",
        "levelOfStudyId",
        "entryYear",
        "yearOfGraduation",
        "ownership",
        "region",
        "town",
      ];

      results.forEach((res, index) => {
        requiredFields.forEach((element) => {
          if (!res[element]) {
            errors.push({
              message: `Please fill in ${element} column`,
              row: index + 1,
            });
          }
        });
      });

      if (errors.length > 1) {
        errors = errors.reduce(function (r, a) {
          r[a.row] = r[a.row] || [];
          r[a.row].push(a.message);
          return r;
        });
        delete errors["message"];
        delete errors["row"];
        this.importErrors = errors;
        this.importErrorsDialog = true;
        return;
      } else {

        this.importErrorsDialog = false;
        this.showUpload = true;
        this.tableData = results;
        this.fileName = fileName;
      }
    },
    async uploadGraduates() {
      if (this.tableData.length === 0) {
        this.$toast.error("No file detected, Please provide one!");
        return;
      }
      this.loading = true;
      const params = this.tableData.map((item) => {
        item.studentStatuses = [];
        const studentStatus = {
          yearOfEducation: item.yearOfEducation,
          gpa: item.gpa,
          studentStatus: item.studentStatus,
        };

        item.studentStatuses.push(studentStatus);
        delete item.yearOfEducation;
        delete item.gpa;
        delete item.studentStatus;
        return item;
      });
      console.log(params);
      let res = await GraduateService.importGenericEntry(this.tableData);
      if (res.status === 200) {
        this.showUpload = false;
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.fetchImportedGraduates();
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      } else {
        this.showUpload = false;
        this.fetchImportedGraduates();
        this.$toast.error(
            "There was a problem uploading file, Please try Again!"
        );
      }
    },
    async fetchImportedGraduates() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;

      let searchParams = '&preServiceLevel=GenericEntry';
      this.name !== null && (searchParams += '&name=' + this.name);
      this.idValue !== null && (searchParams += '&idNo=' + this.idValue);
      this.programValue !== null && (searchParams += '&educationProgramId=' + this.programValue.id);
      this.disciplineValue !== null && (searchParams += '&disciplineId=' + this.disciplineValue.id);
      this.levelOfStudyValue !== null && (searchParams += '&levelOfStudyId=' + this.levelOfStudyValue.id);


      let res = await GraduateService.getPostServices(page, itemsPerPage, searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.showTable = true;
        this.tableData = res.data;
      }
    },
    viewImportedGraduates(item) {
      this.graduates = item;
      this.detailDialog = true;
      this.title = "Generic Entries Detail";
    },
    editImportedGraduate(item) {
      this.addDialog = true;
      this.title = "Edit Generic Entry";
      this.graduates = item;
    },
    async updateImportedGraduate(graduates) {
      this.loading = true;
      let res = null;
      res = await GraduateService.updatePreService(
          graduates.id,
          graduates
      );

      if (res.status === 201) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.fetchImportedGraduates();
            break;
          case 500:
            this.$toast.error(res.data.message);
            this.loading = false;
            break;
        }
      } else {
        this.$toast.error("Unable to Update pre-service, please try again");
      }
    },
    addGenericEntry() {
      this.graduates = null;
      this.title = "Add Generic Entry";
      this.addDialog = true;
    },
    async registerOrUpdateGenericEntries(graduates) {
      let res = null;

      if (graduates.editMode) {
        res = await GraduateService.updatePreService(
            graduates.id,
            graduates
        );

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchImportedGraduates();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update generic entry, please try again");
        }
      } else {

        res = await GraduateService.createPreService(graduates);
        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchImportedGraduates();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create generic entry, please try again");
        }
      }
    },
  },
};
</script>
<style scoped>
.selected {
  line-height: 16px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
